import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import { observer } from 'mobx-react';
import ParagraphsInput from './ParagraphsInput';
import { isRequired } from '../../../../core/validations/index';
import FormService from '../../../../core/services/FormService';
import confirmationDialogService from '../../../../core/services/ConfirmationDialogService';

class ParagraphsInputContainer extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    errors: PropTypes.object,
    submitting: PropTypes.bool,
    values: PropTypes.object,
  };

  static defaultProps = {
    label: 'Add',
    errorText: null,
    disabled: false,
    values: null,
  };

  formService = new FormService();
  state = {
    paragraphs: [],
  };

  componentDidMount() {
    this.formService.validations = {
      text: [isRequired],
      order: [isRequired],
    };
    this.formService.setInitialValues({});

    const text = get(this.props.values, 'text', '');
    const translation = get(this.props.values, 'translation', '');
    const spanishTranslation = get(this.props.values, 'spanishTranslation', '');

    if (text.length > 0) {
      this.setState({
        paragraphs: text.split('\n').map((value, index) => ({
          id: index + 1,
          text: value,
          translation: translation.split('\n')[index],
          spanishTranslation: spanishTranslation.split('\n')[index],
          order: index + 1,
        })),
      });
    }
  }

  getValueFromParagraphs = key => this.state.paragraphs.map(value => value[key]).join('\n');

  handleSubmit = () => {
    this.formService.setSubmitted();

    if (this.formService.errors) {
      return;
    }

    let updatedParagraphs = [];

    if (!this.formService.getValue('id')) {
      updatedParagraphs = [
        ...this.state.paragraphs,
        {
          id: new Date().toISOString(),
          ...this.formService.getValues(),
          text: this.formService.getValue('text').trim(),
          translation: this.formService.getValue('translation').trim(),
          spanishTranslation: this.formService
            .getValue('spanishTranslation')
            .trim(),
        },
      ];
    } else {
      updatedParagraphs = this.state.paragraphs.map(paragraph => {
        if (paragraph.id === this.formService.getValue('id')) {
          return {
            ...this.formService.getValues(),
            text: this.formService.getValue('text').trim(),
            translation: this.formService.getValue('translation').trim(),
            spanishTranslation: this.formService
              .getValue('spanishTranslation')
              .trim(),
          };
        }
        return paragraph;
      });
    }

    updatedParagraphs = orderBy(updatedParagraphs, x => get(x, 'order'), ['asc']);

    this.setState(
      {
        paragraphs: updatedParagraphs,
      },
      () => {
        this.handleReset();
        this.props.onChange('text', this.getValueFromParagraphs('text'));
        this.props.onChange('translation', this.getValueFromParagraphs('translation'));
        this.props.onChange('spanishTranslation', this.getValueFromParagraphs('spanishTranslation'));
      }
    );
  };

  handleEdit = id => {
    this.formService.setInitialValues(this.state.paragraphs.find(paragraph => paragraph.id === id));
  };

  handleReset = () => {
    this.formService.setInitialValues({});
    this.formService.reset();
  };

  handleDelete = id => {
    confirmationDialogService.show('Delete Paragraph', 'You are about to delete the paragraph, are you sure?', () => {
      const updatedParagraphs = this.state.paragraphs.filter(paragraph => paragraph.id !== id);

      this.setState(
        {
          paragraphs: updatedParagraphs,
        },
        () => {
          this.props.onChange('text', this.getValueFromParagraphs('text'));
          this.props.onChange('translation', this.getValueFromParagraphs('translation'));
          this.props.onChange('spanishTranslation', this.getValueFromParagraphs('spanishTranslation'));
        }
      );
    });
  };

  render() {
    return (
      <div>
        <ParagraphsInput
          paragraphs={this.state.paragraphs}
          values={this.formService.getValues()}
          onChange={this.formService.setValue}
          onReset={this.handleReset}
          onDelete={this.handleDelete}
          onEdit={this.handleEdit}
          onSubmit={this.handleSubmit}
          errors={this.formService.errors}
          errorText={get(this.props.errors, 'text', null)}
          disabled={this.props.disabled}
          submitting={this.props.submitting}
          isDirty={this.formService.isDirty}
        />
      </div>
    );
  }
}

export default observer(ParagraphsInputContainer);
